//
//	Mini CMS in javascript functionality that is used across multiple sites.
//
export var api_url = (process.env.NODE_ENV === 'development') ? 'http://' + document.domain : '';


//	Should be able to run in react normally will do if statements, where needed.
// console.log( process.env.NODE_ENV ); // when rending through ssr value is: production 



//
//	Get text for the current page. Will return the data and we can use a dispatcher to update values.
//
export function setText(props) {

	//Load Users from Ajax Call
	fetch( api_url + '/api/get-context/' )
	.then( results => { return results.json() })
	.then( data => {
		
		//	 Dispatch to event to update 
		props.dispatch({type: 'GET_TEXT', data:data});
		
	})
	
}

//
//	Load online users, and dispatch to update data.
//
export function setUsers(props) {

	// This will load either the initiall list of maybe 20 users, and a full list of maybe 1000 users.
	if( props.usersCompleteLoad ) {
		var url = '/api/get-users/az/';
	} else {
		var url = '/api/get-users/';
	}

	//Load Users from Ajax Call
	
	fetch( api_url + url )
	  .then( results => { return results.json() })
	  .then( data => {
		if( data.total > 0 ) {
			props.dispatch({type: 'GET_USERS', data:data})
		}
		//console.log( '1 Get users.')
	  })
	  .then(models => {
		
		// Make sure the .then change works the way we think it does..

		//	ORDER USERS be DEFAULT, this is whatever is used in the store
		props.dispatch({type: 'ORDER_USERS', order: 'STATE'});

		//console.log( '2 Sort Users.')

	}).then( models=> {

		//	Display additional more users..
		if( url === '/api/get-users/az/' ){
			
			//	After we set users from the complete load we will want to show additional users to fix the scrolling issue and also make it look like more users have loaded.
			props.dispatch({type: 'MORE_USERS'});
			//
			setTimeout(() => { props.dispatch({type: 'MORE_USERS_DONE'}); }, 1000 );

			//console.log( '3 Only called on complete load show additional users. Sort Users.')

		}
	});
	
}

//
//	Get current user.
//
export function getChatrooom(props) {

	//Load Users from Ajax Call
	
	fetch( api_url + '/api/get-chatroom/' )
	.then( results => { return results.json() })
	.then( data => {

		props.dispatch({type: 'GET_CHATROOM', data:data})

	})

}


// WEBPACK FOOTER //
// ./src/cms.js